import type { Environment } from '@change-corgi/config/environments';

import __perimeterx from '../config/perimeterx.json';

export const perimeterxConfigs = __perimeterx as Readonly<
	Record<Environment, Readonly<{ appId: string; jsSrc: string }>>
>;
